var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adItem && _vm.adItem.content)?_c('div',[_c('iframe',{ref:"youtubeIframe",staticClass:"ad-design",attrs:{"id":"youtube-iframe","src":_vm.youtubeUrl,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }